// eslint-disable-next-line no-restricted-imports
import { TokenModel, TokenResponse } from 'types';
import genericNormalizer, { normalizeDate } from './generic';

export const normalizeToken = genericNormalizer<TokenResponse, TokenModel>(
  ({ from, has }) => ({
    id: from('id'),
    identifier: from('identifier'),
    permissions: from('permissions'),
    dateCreated: has('dateCreated', normalizeDate),
    dateExpires: has('dateExpires', normalizeDate),
  }),
);



// WEBPACK FOOTER //
// ./app/gamma/src/api/normalizers/token.ts